import React, { Fragment, Component } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import CategoryForm from "./components/form";
import Service from "../../services/brandCategoryService";
class CreateCategory extends Component {
  state = {
    infoData: [],
    info: { sUrl: "" },
    isEdit: true,
  };
  componentWillMount() {
    const { match } = this.props;
    const { params } = match;
    const { categoryId } = params;
    this.setState({ loader: true, categoryId }, function () {
      this.callApiInfo();
    });
  }
  componentDidUpdate() {
    const { match } = this.props;
    const { params } = match;
    const { categoryId } = params;
    if (this.state.categoryId !== categoryId) {
      this.setState(
        {
          loader: true,
          infoData: [],
          searchText: "",
          page: 0,
          pageSize: 10,
          totalRecords: 0,
          startDate: "",
          endDate: "",
          categoryId: categoryId,
        },
        function () {
          this.callApiInfo();
        }
      );
    }
  }
  callApiInfo = () => {
    const { categoryId, pageSize } = this.state;
    Service.fetchCategorysInfo(categoryId).then((response) => {
      if (!response.error) {
        this.setState({
          modalFormShow: false,
          loader: false,
          info: response.data,
          imageUrl: response.data.imageUrl,
        });
      } else {
        this.setState({
          loader: false,
          info: {},
          imageUrl: undefined,
        });
      }
    });
    this.setState({ loader: false });
  };
  addCategoryForm = (data) => {
    const { isEdit, info, imageUrl } = this.state;
    this.setState({ loader: true });
    console.log({ subCategory: info.subCategory });
    data["imageUrl"] = imageUrl;
    data["subCategory"] = info.subCategory;
    data["categoryId"] = isEdit ? info._id : undefined;
    var method = isEdit ? "PUT" : "POST";
    Service.addCategoryInfo(data, method).then((response) => {
      if (!response.error) {
        this.props.history.push("/categories/all");
      }
    });
  };
  onClickToggle = () => {
    this.setState({ modalFormShow: false });
  };

  onChangeImage = (imageUrl) => {
    this.setState({ imageUrl: imageUrl });
  };

  removeImage = () => {
    this.setState({ imageUrl: undefined });
  };

  onChangeUrl = (name, url) => {
    if ((name && name !== "") || (url && url !== "")) {
      console.log({ url });
      var { info, urlEdit } = this.state;
      var stringUrl = "";
      var urlEdit1 = false;
      if (name && !urlEdit) {
        stringUrl = name.toLowerCase();
      } else if (url) {
        stringUrl = url.toLowerCase();
        urlEdit1 = true;
      }
      stringUrl = stringUrl.replace(/ /g, "_");
      stringUrl = stringUrl.replace(/,/g, "_");
      stringUrl = stringUrl.replace(/__/g, "_");
      if (info) {
        info["sUrl"] = stringUrl;
      } else {
        info = { sUrl: stringUrl };
      }
      this.setState({ info: info, urlEdit: urlEdit1 });
    }
  };

  onChangeActive = (categoryId, value, index) => {
    console.log({ categoryId, value });
    const { infoData } = this.state;
    this.setState({ loader: true });
    Service.onCategoryReady(categoryId, value).then((response) => {
      if (!response.error) {
        infoData[index].public = value;
        this.setState({ infoData, loader: false });
        // this.props.history.push("/products/all");
      }
      this.setState({ loader: false });
    });
  };
  render() {
    const {
      categoryStatus,
      infoData,
      modalFormShow,
      loader,
      info,
      index,
      isEdit,
      imageUrl,
    } = this.state;
    const { loading, page, pageSize, totalRecords } = this.state;
    const categoryFormProps = {
      info: info || {},
      imageUrl,
      onChangeImage: this.onChangeImage,
      removeImage: this.removeImage,
      active: this.state.active,
      onChangeUrl: this.onChangeUrl,
      searchProductUrl: "",
      searchUrlStatus: false,
      isEdit: this.state.isEdit,
      onChangeCategoryId: (id) => {
        console.log({ id });
      },
      onClickConfirm: (data) => {
        //console.log(data)
        this.addCategoryForm(data);
      },
      onClickActive: (active) => {
        this.setState({ active });
      },
      onChangeSubCategory: (subCategory) => {
        // var subCategory1 = [];
        // for (let i = 0; i < subCategory.length; i++) {
        //   subCategory1.push(subCategory[i]["label"]);
        // }
        for (let i = 0; i < subCategory.length; i++) {
          subCategory[i]["customOption"] = undefined;
        }
        info.subCategory = subCategory;
        this.setState({ info });
      },
      // CategoryForm: infoData,
    };
    return (
      <Fragment>
        <Breadcrumb title={"Update"} parent="Category" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card border-0" style={{
                boxShadow: "1px 5px 24px 0 rgba(68, 102, 242, .05)",
                padding: "30px",
              }}>
                {loader && (
                  <div
                    style={{
                      position: "fixed",
                      top: "50%",
                      right: "45%",
                      zIndex: "+999",
                    }}
                  >
                    <div className="loader bg-white">
                      <div className="whirly-loader"> </div>
                    </div>
                  </div>
                )}

                <CategoryForm {...categoryFormProps} />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default CreateCategory;
